import { AdaColor, IThemeModel } from '@adaptiva/core/themes';
import { inject, Injector, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'adaLlmHistoryNodeColor'
})
export class LlmHistoryNodeColorPipe implements PipeTransform {

	protected readonly injector: Injector = inject(Injector);

	public transform(_isInFork: boolean, _theme: IThemeModel): AdaColor {
		return _isInFork
			? AdaColor.fromRgb(_theme.primaryColor)
			: AdaColor.fromRgb(_theme.backgroundColor).darken(10);
	}

}
